export default __webpack_public_path__ + "0dc5c29b8b33a65f1629483c6fe80332.png";